export default __webpack_public_path__ + "static/media/HOOK AND QUICK LEFTRIGHT DRILL TRAINING SETUP.24e7ddfe.jpg";